import { createFileRoute } from "@tanstack/react-router";
import { PublicExperienceRequestDetail } from "@/features/research";
import { loadPublicExperienceRequest } from "@/features/game-resources/records";
import {
  resourceHead,
  ResultsFrame,
  resourceSearchSchema,
} from "@/features/game-resources/navigation";

export const Route = createFileRoute("/_site/experience-requests/$requestId")({
  validateSearch: (search) => resourceSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ params, deps, abortController }) =>
    loadPublicExperienceRequest({
      data: { resourceId: params.requestId, search: deps.search },
      signal: abortController.signal,
    }),
  head: () => resourceHead("Experience results"),
  component: Page,
});

function Page() {
  const data = Route.useLoaderData();
  const { requestId } = Route.useParams();
  return (
    <ResultsFrame viewer={data.viewer}>
      <PublicExperienceRequestDetail
        key={requestId}
        requestId={requestId}
        initialData={data.detail}
        initialDataUpdatedAt={data.generatedAt}
      />
    </ResultsFrame>
  );
}
